import CustomAction, {
  BaseActionInputData,
  COMMON_ACTION_TAGS,
  ActionDataType,
} from '../BaseCustomAction';

// CanvasEmbed Specific Input Data
export interface CanvasLoadedInputData extends BaseActionInputData {
  status: number;
  userId: string;
  canvasId: string;
  filterSignature: Record<string, string | number>;
}

// CanvasEmbed Specific Tags
export const CANVAS_ACTION_TAGS = {
  ...COMMON_ACTION_TAGS,
  STATUS: 'status',
  CANVAS_ID: 'canvas_id',
  USER_ID: 'user_id',
} as const;

export class CanvasLoadedAction extends CustomAction<CanvasLoadedInputData> {
  name = 'Canvas Loaded';

  type = ActionDataType.Time;

  // eslint-disable-next-line class-methods-use-this
  prepareTags(input: CanvasLoadedInputData): Record<string, any> {
    const tags: Record<string, any> = {
      [CANVAS_ACTION_TAGS.USER_ID]: input.userId,
      [CANVAS_ACTION_TAGS.CANVAS_ID]: input.canvasId,
      [CANVAS_ACTION_TAGS.STATUS]: input.status,
    };

    // canvas filter params are prefixed with "select_" and those are the only ones we want to track
    if (input.filterSignature && typeof input.filterSignature === 'object') {
      Object.entries(input.filterSignature).forEach(([key, value]) => {
        if (key.startsWith('select_')) {
          tags[key] = value;
        }
      });
    }

    return tags;
  }
}
